import {SUPABASE_ANON_KEY, SUPABASE_URL} from '../config';

const COLUMNS = 'id,type,title,description,path,created_at,read_at';

async function request(query, {method = 'GET', body} = {}) {
  const token = window.localStorage.getItem('accessToken');
  const base = String(SUPABASE_URL || '').replace(/\/$/, '');
  if (!base || !SUPABASE_ANON_KEY) throw new Error('A integração de notificações não está configurada.');
  if (!token) throw new Error('Sua sessão expirou. Faça login novamente.');

  const response = await fetch(`${base}/rest/v1/notifications?${new URLSearchParams(query)}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      apikey: SUPABASE_ANON_KEY,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const raw = await response.text();
  let payload = null;
  try {
    payload = raw ? JSON.parse(raw) : null;
  } catch (error) {
    payload = raw;
  }
  if (!response.ok) throw new Error(payload?.message || 'Não foi possível carregar as notificações.');
  return payload;
}

export async function fetchNotifications(workspaceId) {
  if (!workspaceId) return [];
  const result = await request({
    select: COLUMNS,
    workspace_id: `eq.${workspaceId}`,
    order: 'created_at.desc',
    limit: '50',
  });
  return Array.isArray(result) ? result : [];
}

export function markNotificationRead(id) {
  if (!id) return Promise.resolve();
  return request({id: `eq.${id}`, read_at: 'is.null'}, {
    method: 'PATCH',
    body: {read_at: new Date().toISOString()},
  });
}

export function markAllNotificationsRead(workspaceId) {
  if (!workspaceId) return Promise.resolve();
  return request({workspace_id: `eq.${workspaceId}`, read_at: 'is.null'}, {
    method: 'PATCH',
    body: {read_at: new Date().toISOString()},
  });
}
